import { env } from '@/env';
import { mediaUrl, type MediaSize } from '@restaurant/types';

export function mediaSrc(key: string, size: MediaSize): string {
  return mediaUrl(key, size, env.mediaBaseUrl);
}
